import { defineStore } from "pinia";
import { api } from "@/configs";
import { apiUrls } from "@/constants";
import Swal from "sweetalert2";

export const useChatGroupStore = defineStore("chatGroup", {
    state: () => ({
        chatGroup: [],
    }),

    actions: {

        async fetchChatGroups() {
            try {
                const response = await api.get(apiUrls.chatGroups);
                this.chatGroup = response.data?.data ?? [];
            } catch (error) {
                console.error("Error fetching splash screen:", error);
                this.chatGroup = [];
            }
        },

        async deleteChatGroup(chatGroupId) {
            try {
                await api.delete(`${apiUrls.chatGroups}/${chatGroupId}`);

                // Correct way to remove item from array
               this.chatGroup = this.chatGroup.filter(
                    (chatGroup) => chatGroup.id !== chatGroupId
                );

                Swal.fire("Chat Group Deleted Successfully", "", "success");
                return true;
            } catch (error) {
                console.error(error);
                Swal.fire("Failed to delete Splash Screen", "", "error");
                return false;
            }
        },



    },


});